// src/pinball/tables/index.ts - Barrel export for all table configurations

import { TableThemeConfig } from '../types';
import { ClassicArcadeTable } from './ClassicArcadeTable';
import { SpaceAdventureTable } from './SpaceAdventureTable';
import { JungleQuestTable } from './JungleQuestTable';

export { ClassicArcadeTable } from './ClassicArcadeTable';
export { SpaceAdventureTable } from './SpaceAdventureTable';
export { JungleQuestTable } from './JungleQuestTable';

export const ALL_TABLES: TableThemeConfig[] = [
  ClassicArcadeTable,
  SpaceAdventureTable,
  JungleQuestTable,
];

export function getTableById(id: string): TableThemeConfig | undefined {
  return ALL_TABLES.find(t => t.id === id);
}

export function validateTableConfig(config: TableThemeConfig): string[] {
  const errors: string[] = [];

  if (!config.id) errors.push('Table must have an id');
  if (!config.name) errors.push('Table must have a name');
  if (config.width <= 0) errors.push('Table width must be positive');
  if (config.height <= 0) errors.push('Table height must be positive');
  if (config.flippers.length < 2) errors.push('Table must have at least 2 flippers');
  if (!config.plunger) errors.push('Table must have a plunger');
  if (!config.drain) errors.push('Table must have a drain');
  if (!config.scoring) errors.push('Table must have scoring config');

  return errors;
}
